if (typeof window !== "undefined" && !window.ModalDialog) {
	class ModalDialog extends HTMLElement {
		constructor() {
			super();
			const closeEl = this.querySelector('[id^="ModalClose-"]');
			if (closeEl) closeEl.addEventListener("click", this.hide.bind(this, false));

			this.addEventListener("keyup", event => {
				if (event.code && event.code.toUpperCase() === "ESCAPE") this.hide();
			});

			if (this.classList.contains("media-modal")) {
				this.addEventListener("pointerup", event => {
					if (event.pointerType === "mouse" && !event.target.closest("deferred-media, product-model")) this.hide();
				});
			} else {
				this.addEventListener("click", event => {
					if (event.target === this) this.hide();
				});
			}
		}

		connectedCallback() {
			if (this.moved) return;
			this.moved = true;
			document.body.appendChild(this);
		}

		show(opener) {
			this.openedBy = opener;
			const popup = this.querySelector(".template-popup");
			document.body.classList.add("overflow-hidden");
			this.setAttribute("open", "");
			if (popup && typeof popup.loadContent === "function") popup.loadContent();
			if (typeof window.trapFocus === "function") window.trapFocus(this, this.querySelector('[role="dialog"]'));
			if (typeof window.pauseAllMedia === "function") window.pauseAllMedia();
		}

		hide() {
			document.body.classList.remove("overflow-hidden");
			document.body.dispatchEvent(new CustomEvent("modalClosed"));
			this.removeAttribute("open");
			if (typeof window.removeTrapFocus === "function") window.removeTrapFocus(this.openedBy);
			if (typeof window.pauseAllMedia === "function") window.pauseAllMedia();
		}
	}

	window.ModalDialog = ModalDialog;
	if (!customElements.get("modal-dialog")) {
		customElements.define("modal-dialog", ModalDialog);
	}
}

